<template>
    <div>
      <recruit/>
    </div>
</template>
<script>
import Recruit from '../components/recruit/RecruitComponent.vue'
export default {
	name: 'Page3',
	components: { Recruit }
}
</script>
